import styled from 'styled-components';
import { grayLightSphera, greenSp } from 'src/utilities/UIStyles/variables/Colors';

export const BannerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background-color: ${grayLightSphera};
  color: white;
  padding: 1% 5%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

export const BannerText = styled.p`
  margin: 0;
  width: 100%;
  font-size: 1.2vw;
`;

export const BannerButton = styled.button`
  background-color: ${greenSp};
  color: white;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
`;

export const DismissText = styled.span`
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
`;
